import successPhone from './success-phone-dak-bgm.png';
import mobilePhone from './antistress-coaching-course-desktop@2x.png';
import logoHeader from './DAKGesLogoClaim.svg';

export const successPhoneImage = successPhone;
export const mobilePhoneImage = mobilePhone;
export const logoHeaderImage = logoHeader;
